import './category-content.scss';

import Swiper from 'swiper';
import { Navigation, Mousewheel } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/mousewheel';

class CategoryContent {
    constructor (element) {
        this.$categoryContent = element;
        this.$categoryContentTopics = this.$categoryContent.querySelector('[data-category-content="topics"]');
        this.$categoryContentContents = this.$categoryContent.querySelector('[data-category-content="contents"]');

        this.activeTopic = this.$categoryContent.querySelector('.is--active').getAttribute('data-category-content-topic-id');

        this.slider = null;
        this.$sliderContainer = this.$categoryContent.querySelector('[data-category-content="slider"]');
        this.sliderActive = false;
    }

    initialize () {
        this.checkSizes();
        this.setEvents();
    }

    setEvents () {
        const $topics = this.$categoryContentTopics.querySelectorAll('[data-category-content-topic-id]');

        $topics.forEach(($topic) => {
            $topic.addEventListener('click', () => {
                const id = $topic.getAttribute('data-category-content-topic-id');

                if (id !== this.activeTopic) {
                    this.setTopicListItem($topic);
                    this.setTopicContent(id);
                    this.activeTopic = id;
                }
            });
        });
    }

    setTopicListItem ($topic) {
        if (this.activeTopic !== '') {
            const $activeTopics = this.$categoryContentTopics.querySelectorAll('.is--active');

            $activeTopics.forEach(($activeTopic) => {
                $activeTopic.classList.remove('is--active');
            });
        }

        $topic.classList.add('is--active');
    }

    setTopicContent (id) {
        if (this.activeTopic !== '') {
            const $activeContents = this.$categoryContentContents.querySelectorAll('[data-category-content-topic-id].is--active');

            $activeContents.forEach(($content) => {
                $content.classList.add('is--hidden');
                setTimeout(() => {
                    $content.classList.remove('is--active');
                    $content.classList.remove('is--hidden');
                }, 250);
            });
        }

        const $content = this.$categoryContentContents.querySelector('[data-category-content-topic-id="' + id + '"]');
        setTimeout(() => {
            $content.classList.add('is--active');
        }, 250);
    }

    initSlider () {
        this.sliderActive = true;

        this.slider = new Swiper(this.$sliderContainer, {
            modules: [Navigation, Mousewheel],
            slidesPerView: 'auto',
            speed: 500,
            autoHeight: false,
            resistanceRatio: 0,
            centeredSlides: true,
            centeredSlidesBounds: true,
            threshold: 10,
            slideToClickedSlide: true,
            mousewheel: {
                forceToAxis: true
            },
            navigation: {
                nextEl: this.$categoryContent.querySelector('.category-content__topics-next'),
                prevEl: this.$categoryContent.querySelector('.category-content__topics-prev')
            }
        });
    }

    destroySlider () {
        if (this.slider !== null) {
            this.slider.destroy(true, true);
            this.slider = null;
            this.sliderActive = false;
        }
    }

    checkSizes () {
        if (!window.mediaMatch[1024].matches) {
            this.initSlider();
        }

        window.mediaMatch[1024].addEventListener('change', (match) => {
            if (!match.matches && !this.sliderActive) {
                this.initSlider();
            }

            if (match.matches && this.sliderActive) {
                this.destroySlider();
            }
        });
    }
}

export { CategoryContent };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$categoryContents = $context.querySelectorAll('[data-category-content="root"]');

        $$categoryContents.forEach($categoryContent => {
            const categoryContent = new CategoryContent($categoryContent);
            categoryContent.initialize();
        });
    }
});
